<template>
	<v-dialog v-model="showDialog" :max-width="maxWidth" :persistent="persistent">
		<v-card class="d-flex flex-column mg-dialog-card">
			<v-card-title class="header">
				<div class="v-card-title">
					<img :src="icon" class="icon" v-if="icon">
					<span class="title">{{ title }}</span>
				</div>
			</v-card-title>
			<v-card-text :style="contentStyle">
				<slot name="content"></slot>
			</v-card-text>
			<v-card-actions class="justify-center">
				<div class="d-flex flex-column align-center">
					<slot name="actions"></slot>
				</div>
			</v-card-actions>
			<v-card-text class="footer">
				<slot name="footer"></slot>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "MGDialog",
	props: {
		modelValue: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: String,
			default: "500px"
		},
		persistent: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: ""
		},
		icon: {
			type: String,
			default: ""
		},
		contentHeight: {
			type: String,
			default: "300px"
		}
	},
	computed: {
		showDialog: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('update:modelValue', value);
			}
		},
		contentStyle() {
			return {
				height: this.contentHeight,
				overflowY: 'auto'
			};
		}
	}
}
</script>

<style scoped>
.icon {
	width: 48px;
	height: 32px;
	border-radius: 4px;
	margin-right: auto;
	margin-left: -8px;
	vertical-align: middle;
}
.title {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	text-align: center;
	font-size: 15px;
	font-weight: bold;
	width: max-content;
}
.footer {
	width: 100% !important;
	margin: 0 !important;
	padding: 0 !important;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	margin-top: auto;
}

:deep(.footer.v-card-text) {
	padding-left: 0 !important;
	padding-right: 0 !important;
}

/* Make v-card components have rounded corners */
:deep(.v-card) {
	border-radius: 16px !important;
}

/* Make v-card-actions fill full width */
:deep(.v-card-actions) {
	width: 100% !important;
	padding: 16px !important;
}

:deep(.v-card-actions .d-flex) {
	width: 100% !important;
}

/* Make buttons in dialog full width */
:deep(.v-dialog .v-card-actions .mg-button) {
	width: 100% !important;
}

:deep(.v-dialog .v-card-actions button) {
	width: 100% !important;
}

/* Add padding to dialog card */
.mg-dialog-card {
	/* Remove vertical padding so footer can reach the bottom */
	padding-top: 0 !important;
	padding-bottom: 0 !important;
}

:deep(.v-card-text) {
	width: 100%;
	box-sizing: border-box;
	padding-left: 24px;
	padding-right: 24px;
}

:deep(.v-card-text .v-text-field) {
	width: 100%;
}

@media (max-height: 670px) {
	.header {
		display: none !important;
	}
}
</style>